<template>
    <div class="groom mt-md w-100">
        <PatentList
            :key="updater"
            inline
            absolute
            entity-only
            allow-pruning
            :passed-filters="props.passedFilters"
            :entity-pk="parseInt(entityStore.entity.aon_entity_pk)"
            ref="patentListRef"
        />
    </div>
</template>

<script setup>
import { onMounted, ref, inject, watch, computed, onDeactivated } from 'vue'
import { usePortfolioManagerStore, useEntityStore } from '@/stores'

import PatentList from '@/components/patentViewer/PatentList.vue'

const portfolioManagerStore = usePortfolioManagerStore()
const entityStore = useEntityStore()
const patentListRef = ref(null)

const updater = ref(0)

const props = defineProps({
    passedFilters: {
        type: Object,
        default: () => ({}),
    },
})

watch(
    () => portfolioManagerStore.dateRange,
    () => {
        updater.value++
    },
    { immediate: true }
)

onDeactivated(() => {
    if (patentListRef.value?.clearFilters) {
        patentListRef.value.clearFilters()
    }
})
</script>
<style lang="scss" scoped>
.groom {
    min-height: calc(100vh - 160px);
    position: relative;
}
</style>
